module.exports = __webpack_public_path__ + "img/arrowDown.35daa7fb.svg";